import React from 'react';
import PropTypes from 'prop-types';
import DownloadButton from './public/DownloadButton';

const TravelPastByTheHourGraph = props => {
  const topPercentage =
    props.data[
      props.data
        .map(hour => hour.percent)
        .reduce((iMax, x, i, arr) => (x > arr[iMax] ? i : iMax), 0)
    ].percent;
  return (
    <div className="TravelPastByTheHourGraph">
      <h3 className="content-card_title" style={{ display: 'inline-block' }}>
        {props.title}
      </h3>

      {props.downloadOpen && (
        <DownloadButton
          styleObj={{ display: 'inline-block', float: 'right' }}
          downloadAudience={props.downloadAudience}
          downloadingCSV={props.downloadingCSV}
          reportType={props.reportType}
          insightType={props.insightType}
          downloadParams={props.downloadOpen}
        />
      )}

      <div className="TravelPastByTheHourGraph_barchart">
        <ul className="Barchart_ul">
          {props.data.map(item => (
            <li className="Barchart_li" key={item.hour}>
              <span className="Barchart_hour">{item.hour}:00</span>
              <span className="Barchart_name">{item.name}</span>
              <span className="Barchart_bars">
                <span className="Barchart_bar-wrapper">
                  <span
                    className="Barchart_bar_this-month"
                    style={{
                      height: `${(item.percent / topPercentage) * 100}%`,
                    }}
                  >
                    <span className="Barchart_percent">
                      {Math.round(item.percent) !== 0
                        ? Math.round(item.percent)
                        : `<1`}
                      %
                    </span>
                  </span>
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TravelPastByTheHourGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TravelPastByTheHourGraph;
